import React, { useState, useRef } from "react";
import { saveAs } from "file-saver";
import { Button } from "react-bootstrap";
import { CreacionTitulosService } from "../../../../_services/creaciontitulos.service";
import BasicProcessingModal from "../../../../components/LoadingModal/BasicProcessingModal";

const XlsGeneratorHome = () => {
  const [file, setFile] = useState(null);
  const [category, setCategory] = useState("");
  const [modalStatus, setModalStatus] = useState({status: null, message: ""}); // "processing", "success", o null
  const isSubmitDisabled = !file || !category;
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleCategoryChange = (e) => {
    setCategory(e.target.value);
  };

  const resetFileInput = () => {
    setFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const restartStates = () => {
    setCategory("");
    resetFileInput();
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleSubmit = async () => {
    if (!file) {
      alert("Por favor, selecciona un archivo.");
      return;
    }
    const formData = new FormData();
    formData.append("file", file);
    try {
      setModalStatus({status: "processing", message: "Procesando Excel..."});
      const response = await CreacionTitulosService.postGenerateXLS(file, category);
      const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      setModalStatus({status: "success", message: "Excel Procesado con éxito!!", time: 3000});
      saveAs(blob, `${file.name}_procesado.xlsx`);
      restartStates();
    } catch (error) {
      console.error("Error al enviar el archivo", error);
      setModalStatus({status: "error", message: "Error al procesar el excel", time: 3000});
      restartStates();
    }
  };

  const handleDownloadSLXBase = async () => {
    try {
      const response = await CreacionTitulosService.getXlsBase();
      const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      saveAs(blob, "ExcelBasicoCreacionTitulos.xlsx");
    } catch (error) {
      console.error("Error al enviar el archivo", error);
      alert("Error al enviar el archivo");
    }
  };

  return (
    <div className="container mt-5">
      <div className="card p-4 shadow">
        <h3 className="text-center mb-4">Generador de Archivos XLS</h3>
        <div className="mb-3">
          <label className="form-label">Selecciona una categoría:</label>
          <select
            className="form-select"
            value={category}
            onChange={handleCategoryChange}
          >
            <option value="">-- Selecciona una opción --</option>
            <option value="inmueble">Inmueble</option>
            <option value="comercio">Comercio</option>
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label">Selecciona un archivo:</label>
          <input
            ref={fileInputRef}
            className="form-control"
            type="file"
            accept=".xlsx, .xls"
            onChange={handleFileChange}
          />
        </div>

        <div className="text-center">
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={isSubmitDisabled}
          >
            Enviar archivo
          </Button>
        </div>
      </div>
      <div className="card p-4 shadow">
        <h3>Descarga Excel Básico</h3>
        <p>Para descargar el excel base para su llenado y luego procesamiento haga click en el siguiente botón</p>
        <div className="text-center">
          <Button
            variant="primary"
            onClick={handleDownloadSLXBase}
          >
            Descargar Ejemplo Base
          </Button>
        </div>
      </div>
      <BasicProcessingModal status={modalStatus} onClose={() => setModalStatus({status: undefined, message: ""})} />
    </div>
  );
};

export default XlsGeneratorHome;